"use client";

import { useAuthStore } from "@/stores/useAuthStore";
import { getUsernameFromEmail } from "@/utils/utils";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { useEffect } from "react";

export default function Header() {
  const { user, isAdmin, fetchUser, logout } = useAuthStore();
  const router = useRouter();

  useEffect(() => {
    fetchUser();
  }, []);

  const handleLogout = async () => {
    await logout();
    router.push("/login");
  };

  return (
    <header className="px-8 py-3 bg-white shadow-lg mb-12">
      <div className="flex items-center justify-end max-w-[1400px] w-full m-auto space-x-4">
        {user && !isAdmin && (
          <Link className="text-black hover:underline" href="/device">
            Masin
          </Link>
        )}
        {user && !isAdmin && (
          <Link className="text-black hover:underline" href="/error-alerts">
            Veateated
          </Link>
        )}
        {user && !isAdmin && (
          <Link
            className="text-black hover:underline"
            href="/maintenance-alerts"
          >
            Hooldusteated
          </Link>
        )}
        {isAdmin && (
          <Link className="text-black hover:underline" href="/users">
            Kasutajad
          </Link>
        )}
        {isAdmin && (
          <Link
            className="text-black hover:underline"
            href="/alert-descriptions"
          >
            Teate kirjeldused
          </Link>
        )}

        {user ? (
          <>
            <button
              className="text-black hover:underline cursor-pointer"
              onClick={handleLogout}
            >
              Logi välja
            </button>
            <span className="ml-4 font-medium text-blue-900">
              {getUsernameFromEmail(user.email)}
            </span>
          </>
        ) : (
          <Link className="text-black hover:underline" href="/login">
            Logi sisse
          </Link>
        )}
      </div>
    </header>
  );
}
